import { useMutation, useQueryClient } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";

type EventRecordMutation = {
  event_name: string;
  data: Record<string, string>;
};

const useEventRecordMutation = () => {
  const queryClient = useQueryClient();
  const { mutate: postEventRecord, data } = useMutation({
    mutationFn: (payload: EventRecordMutation) =>
      api().post(ApiCatalog.eventRecord.endpoint, payload),
    // Event records are highly coupled to user features so clearing
    // feature cache is key for keeping user features updated.
    onSuccess: (_data, { event_name: eventName }) => {
      queryClient.invalidateQueries({
        queryKey: [ApiCatalog.feature.key, "me"],
      });
      queryClient.invalidateQueries({
        queryKey: [ApiCatalog.eventRecord.key, { eventName }],
      });
    },
  });

  return { postEventRecord, data };
};

export default useEventRecordMutation;
